import { render, staticRenderFns } from "./DeleteExpensesType.vue?vue&type=template&id=3ccdcca5&scoped=true"
import script from "./DeleteExpensesType.vue?vue&type=script&lang=js"
export * from "./DeleteExpensesType.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ccdcca5",
  null
  
)

export default component.exports